import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';
import { FormErrorComponent } from '../../form-error/form-error.component';
import { CurrencyInputComponent } from '../../inputs/currency-input/currency-input.component';

@Component({
  selector: 'lib-currency-form-field',
  imports: [FormErrorComponent, CurrencyInputComponent, ReactiveFormsModule],
  templateUrl: './currency-form-field.component.html',
  styleUrl: './currency-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencyFormFieldComponent {
  inputFormControl = input.required<FormControl>();
  label = input.required<string>();
  isSubmitted = input<boolean>(false);
  placeholder = input<string | null | undefined>();
  hintText = input<string | null | undefined>();
  autocomplete = input<string>('on');
  allowNegative = input<boolean>(false);
  inputId: string = uuidv4();
}
